import { jsx } from "react/jsx-runtime";
import { LogoIcon } from "@tamagui/logo";
import { Square } from "tamagui";
function AnimationsHoverDemo() {
  return /* @__PURE__ */ jsx(
    Square,
    {
      borderColor: "$borderColor",
      animation: "bouncy",
      elevation: "$4",
      backgroundColor: "$color9",
      size: 104,
      borderRadius: "$9",
      hoverStyle: {
        scale: 1.2
      },
      pressStyle: {
        scale: 0.9
      },
      children: /* @__PURE__ */ jsx(LogoIcon, { downscale: 0.75 })
    }
  );
}
export {
  AnimationsHoverDemo
};
//# sourceMappingURL=AnimationsHoverDemo.js.map
